<template>
  <div class="page-wrap">
    <img class="d-none" :src="$media_url + currentProfile.photo_path" alt=""
    />
    <div class="page-head">
      <div class="breadcrumbs">
        <div class="h1">
          <router-link v-if="$route.path.indexOf('partners') != -1" class="link-not-like" to="/partners/">
            {{ $vuetify.lang.t('$vuetify.menu.partners') }}
          </router-link>
          <router-link v-if="$route.path.indexOf('find-organizations') != -1" class="link-not-like"
                       to="/find-organizations/">
            {{ $vuetify.lang.t('$vuetify.menu.FindOrganizations') }}
          </router-link>
        </div>
        <svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.27539 13.7068L7.48229 7.49989L1.27539 1.29299" stroke="#2C1521" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <div class="h1">
          {{ currentProfile.name }}
        </div>
      </div>
    </div>

    <v-form class="profile profile--company" ref="form" @submit.prevent="">
      <div class="profile-main cards__single">
        <div class="profile-main__header">
          <div class="flex">
            <div class="profile-main__avatar cp">
              <img class="cp" v-if="currentProfile.logo_path" :src="$media_url + currentProfile.logo_path" alt=""
                   @click="lightboxItems.push($media_url+currentProfile.logo_path); index=0"/>
            </div>
          </div>


          <div class="profile-main__name h2">
            {{ currentProfile.name }}
          </div>


        </div>

        <div class="profile-main__options">
          <div class="profile-main__option">
            <div class="profile-main__option-icon">
              <svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M5.6 17.6005C5.41435 17.6005 5.2363 17.6743 5.10503 17.8056C4.97375 17.9368 4.9 18.1149 4.9 18.3005C4.9 18.4862 4.97375 18.6642 5.10503 18.7955C5.2363 18.9268 5.41435 19.0005 5.6 19.0005H8.4C8.58565 19.0005 8.7637 18.9268 8.89497 18.7955C9.02625 18.6642 9.1 18.4862 9.1 18.3005C9.1 18.1149 9.02625 17.9368 8.89497 17.8056C8.7637 17.6743 8.58565 17.6005 8.4 17.6005H5.6Z"
                  fill="#557EAE"/>
                <path
                  d="M2.8 0.800537C2.05739 0.800537 1.3452 1.09554 0.820101 1.62064C0.294999 2.14574 0 2.85793 0 3.60054V20.4005C0 21.1431 0.294999 21.8553 0.820101 22.3804C1.3452 22.9055 2.05739 23.2005 2.8 23.2005H11.2C11.9426 23.2005 12.6548 22.9055 13.1799 22.3804C13.705 21.8553 14 21.1431 14 20.4005V3.60054C14 2.85793 13.705 2.14574 13.1799 1.62064C12.6548 1.09554 11.9426 0.800537 11.2 0.800537H2.8ZM1.4 3.60054C1.4 3.22923 1.5475 2.87314 1.81005 2.61059C2.0726 2.34804 2.4287 2.20054 2.8 2.20054H11.2C11.5713 2.20054 11.9274 2.34804 12.1899 2.61059C12.4525 2.87314 12.6 3.22923 12.6 3.60054V20.4005C12.6 20.7718 12.4525 21.1279 12.1899 21.3905C11.9274 21.653 11.5713 21.8005 11.2 21.8005H2.8C2.4287 21.8005 2.0726 21.653 1.81005 21.3905C1.5475 21.1279 1.4 20.7718 1.4 20.4005V3.60054Z"
                  fill="#557EAE"/>
              </svg>
            </div>
            <div class="profile-main__option-title">{{ $vuetify.lang.t('$vuetify.phone') }}</div>

            <div class="profile-main__option-val" v-if="currentProfile.phone">
              <a :href="'tel:' + currentProfile.phone.replace(/\D/g, '')">{{ currentProfile.phone }} </a>
            </div>
          </div>
          <div class="profile-main__option">
            <div class="profile-main__option-icon">
              <svg width="24" height="19" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M19.7008 0.599854C20.629 0.599854 21.5193 0.968602 22.1757 1.62498C22.832 2.28136 23.2008 3.1716 23.2008 4.09985V15.2999C23.2008 16.2281 22.832 17.1184 22.1757 17.7747C21.5193 18.4311 20.629 18.7999 19.7008 18.7999H4.30078C3.37252 18.7999 2.48228 18.4311 1.82591 17.7747C1.16953 17.1184 0.800781 16.2281 0.800781 15.2999V4.09985C0.800781 3.1716 1.16953 2.28136 1.82591 1.62498C2.48228 0.968602 3.37252 0.599854 4.30078 0.599854H19.7008ZM21.8008 6.14525L12.3564 11.7033C12.2671 11.7557 12.1673 11.7876 12.0642 11.7968C11.961 11.806 11.8571 11.7922 11.76 11.7565L11.6452 11.7033L2.20078 6.14805V15.2999C2.20078 15.8568 2.42203 16.391 2.81586 16.7848C3.20968 17.1786 3.74383 17.3999 4.30078 17.3999H19.7008C20.2577 17.3999 20.7919 17.1786 21.1857 16.7848C21.5795 16.391 21.8008 15.8568 21.8008 15.2999V6.14525ZM19.7008 1.99985H4.30078C3.74383 1.99985 3.20968 2.2211 2.81586 2.61493C2.42203 3.00876 2.20078 3.5429 2.20078 4.09985V4.52265L12.0008 10.2879L21.8008 4.51985V4.09985C21.8008 3.5429 21.5795 3.00876 21.1857 2.61493C20.7919 2.2211 20.2577 1.99985 19.7008 1.99985Z"
                  fill="#557EAE"/>
              </svg>
            </div>
            <div class="profile-main__option-title">email</div>

            <div class="profile-main__option-val">
              <a :href="'mailto:' + currentProfile.email">{{ currentProfile.email }}</a>
            </div>
          </div>
          <div class="profile-main__option">
            <div class="profile-main__option-icon">
              <svg width="22" height="25" viewBox="0 0 22 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M5.50059 7.80054C5.31493 7.80054 5.13689 7.87429 5.00561 8.00556C4.87434 8.13684 4.80059 8.31489 4.80059 8.50054C4.80059 8.68619 4.87434 8.86424 5.00561 8.99551C5.13689 9.12679 5.31493 9.20054 5.50059 9.20054H12.5006C12.6862 9.20054 12.8643 9.12679 12.9956 8.99551C13.1268 8.86424 13.2006 8.68619 13.2006 8.50054C13.2006 8.31489 13.1268 8.13684 12.9956 8.00556C12.8643 7.87429 12.6862 7.80054 12.5006 7.80054H5.50059ZM4.80059 12.7005C4.80059 12.5149 4.87434 12.3368 5.00561 12.2056C5.13689 12.0743 5.31493 12.0005 5.50059 12.0005H12.0386C11.8846 12.4387 11.8006 12.9105 11.8006 13.4005H5.50059C5.31493 13.4005 5.13689 13.3268 5.00561 13.1955C4.87434 13.0642 4.80059 12.8862 4.80059 12.7005ZM16.0006 4.30054V9.20054C16.4906 9.20054 16.9624 9.28454 17.4006 9.43994V4.30054C17.4006 3.74358 17.1793 3.20944 16.7855 2.81561C16.3917 2.42179 15.8575 2.20054 15.3006 2.20054H14.6006V1.50054C14.6006 1.31489 14.5268 1.13684 14.3956 1.00556C14.2643 0.874287 14.0862 0.800537 13.9006 0.800537C13.7149 0.800537 13.5369 0.874287 13.4056 1.00556C13.2743 1.13684 13.2006 1.31489 13.2006 1.50054V2.20054H9.70059V1.50054C9.70059 1.31489 9.62684 1.13684 9.49556 1.00556C9.36429 0.874287 9.18624 0.800537 9.00059 0.800537C8.81493 0.800537 8.63689 0.874287 8.50561 1.00556C8.37434 1.13684 8.30059 1.31489 8.30059 1.50054V2.20054H4.80059V1.50054C4.80059 1.31489 4.72684 1.13684 4.59556 1.00556C4.46429 0.874287 4.28624 0.800537 4.10059 0.800537C3.91493 0.800537 3.73689 0.874287 3.60561 1.00556C3.47434 1.13684 3.40059 1.31489 3.40059 1.50054V2.20054H2.70059C2.14363 2.20054 1.60949 2.42179 1.21566 2.81561C0.821835 3.20944 0.600586 3.74358 0.600586 4.30054V21.1005C0.600586 21.6575 0.821835 22.1916 1.21566 22.5855C1.60949 22.9793 2.14363 23.2005 2.70059 23.2005H10.0506C9.75247 22.7681 9.51462 22.2971 9.34359 21.8005H2.70059C2.51493 21.8005 2.33689 21.7268 2.20561 21.5955C2.07434 21.4642 2.00059 21.2862 2.00059 21.1005V4.30054C2.00059 4.11489 2.07434 3.93684 2.20561 3.80556C2.33689 3.67429 2.51493 3.60054 2.70059 3.60054H15.3006C15.4862 3.60054 15.6643 3.67429 15.7956 3.80556C15.9268 3.93684 16.0006 4.11489 16.0006 4.30054ZM5.50059 16.2005C5.31493 16.2005 5.13689 16.2743 5.00561 16.4056C4.87434 16.5368 4.80059 16.7149 4.80059 16.9005C4.80059 17.0862 4.87434 17.2642 5.00561 17.3955C5.13689 17.5268 5.31493 17.6005 5.50059 17.6005H8.30059C8.48624 17.6005 8.66429 17.5268 8.79556 17.3955C8.92684 17.2642 9.00059 17.0862 9.00059 16.9005C9.00059 16.7149 8.92684 16.5368 8.79556 16.4056C8.66429 16.2743 8.48624 16.2005 8.30059 16.2005H5.50059ZM18.8006 13.4005C18.8126 13.0256 18.7492 12.652 18.6141 12.3021C18.4789 11.9521 18.2749 11.6328 18.014 11.3633C17.753 11.0937 17.4406 10.8793 17.0952 10.7329C16.7499 10.5864 16.3786 10.5108 16.0034 10.5106C15.6283 10.5104 15.2569 10.5856 14.9114 10.7318C14.5659 10.8779 14.2532 11.092 13.9921 11.3613C13.7309 11.6306 13.5265 11.9496 13.391 12.2994C13.2555 12.6493 13.1917 13.0228 13.2034 13.3977C13.226 14.1247 13.5306 14.8143 14.0527 15.3206C14.5747 15.8269 15.2734 16.1103 16.0006 16.1106C16.7279 16.111 17.4268 15.8284 17.9494 15.3225C18.472 14.8167 18.7772 14.1274 18.8006 13.4005ZM10.4006 19.7005C10.4006 19.9413 10.4146 20.1751 10.4454 20.4005C10.5836 21.5669 11.1775 22.6313 12.0974 23.3615C13.1348 24.1945 14.5264 24.6005 16.0006 24.6005C17.4748 24.6005 18.8664 24.1945 19.9038 23.3615C20.9566 22.5145 21.6006 21.2629 21.6006 19.7005C21.6006 19.1436 21.3793 18.6094 20.9855 18.2156C20.5917 17.8218 20.0575 17.6005 19.5006 17.6005H12.5006C11.9436 17.6005 11.4095 17.8218 11.0157 18.2156C10.6218 18.6094 10.4006 19.1436 10.4006 19.7005Z"
                  fill="#557EAE"/>
              </svg>
            </div>
            <div class="profile-main__option-title">{{ $vuetify.lang.t('$vuetify.website') }}</div>

            <div class="profile-main__option-val">
              <a :href="currentProfile.web" target="_blank">{{ currentProfile.web }}</a>
            </div>
          </div>
          <div class="profile-main__option">
            <div class="profile-main__option-icon">
              <svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M9.99922 0.800537C8.51401 0.800537 7.08962 1.39054 6.03942 2.44074C4.98922 3.49094 4.39922 4.91533 4.39922 6.40054C4.39922 7.88575 4.98922 9.31013 6.03942 10.3603C7.08962 11.4105 8.51401 12.0005 9.99922 12.0005C11.4844 12.0005 12.9088 11.4105 13.959 10.3603C15.0092 9.31013 15.5992 7.88575 15.5992 6.40054C15.5992 4.91533 15.0092 3.49094 13.959 2.44074C12.9088 1.39054 11.4844 0.800537 9.99922 0.800537ZM5.79922 6.40054C5.79922 5.28663 6.24172 4.21834 7.02937 3.43069C7.81702 2.64304 8.88531 2.20054 9.99922 2.20054C11.1131 2.20054 12.1814 2.64304 12.9691 3.43069C13.7567 4.21834 14.1992 5.28663 14.1992 6.40054C14.1992 7.51445 13.7567 8.58273 12.9691 9.37039C12.1814 10.158 11.1131 10.6005 9.99922 10.6005C8.88531 10.6005 7.81702 10.158 7.02937 9.37039C6.24172 8.58273 5.79922 7.51445 5.79922 6.40054Z"
                  fill="#557EAE"/>
                <path
                  d="M3.01182 13.4005C2.64311 13.3991 2.27774 13.4704 1.93665 13.6104C1.59557 13.7505 1.28548 13.9565 1.02418 14.2166C0.762878 14.4767 0.555497 14.7859 0.413932 15.1263C0.272366 15.4668 0.1994 15.8318 0.199219 16.2005C0.199219 18.5679 1.36542 20.3529 3.18822 21.5163C4.98302 22.6601 7.40222 23.2005 9.99922 23.2005C12.5962 23.2005 15.0154 22.6601 16.8102 21.5163C18.633 20.3543 19.7992 18.5665 19.7992 16.2005C19.7992 15.4579 19.5042 14.7457 18.9791 14.2206C18.454 13.6955 17.7418 13.4005 16.9992 13.4005H3.01182ZM1.59922 16.2005C1.59922 15.4263 2.22642 14.8005 3.01182 14.8005H16.9992C17.3705 14.8005 17.7266 14.948 17.9892 15.2106C18.2517 15.4731 18.3992 15.8292 18.3992 16.2005C18.3992 18.0331 17.5284 19.3981 16.057 20.3347C14.559 21.2909 12.4282 21.8005 9.99922 21.8005C7.57022 21.8005 5.43942 21.2909 3.94142 20.3347C2.47142 19.3967 1.59922 18.0345 1.59922 16.2005Z"
                  fill="#557EAE"/>
              </svg>
            </div>
            <div class="profile-main__option-title">{{ $vuetify.lang.t('$vuetify.ogrn') }}</div>

            <div class="profile-main__option-val">
              {{ currentProfile.ogrn }}
            </div>
          </div>
          <div class="profile-main__option">
            <div class="profile-main__option-icon">
              <svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M9.99922 0.800537C8.51401 0.800537 7.08962 1.39054 6.03942 2.44074C4.98922 3.49094 4.39922 4.91533 4.39922 6.40054C4.39922 7.88575 4.98922 9.31013 6.03942 10.3603C7.08962 11.4105 8.51401 12.0005 9.99922 12.0005C11.4844 12.0005 12.9088 11.4105 13.959 10.3603C15.0092 9.31013 15.5992 7.88575 15.5992 6.40054C15.5992 4.91533 15.0092 3.49094 13.959 2.44074C12.9088 1.39054 11.4844 0.800537 9.99922 0.800537ZM5.79922 6.40054C5.79922 5.28663 6.24172 4.21834 7.02937 3.43069C7.81702 2.64304 8.88531 2.20054 9.99922 2.20054C11.1131 2.20054 12.1814 2.64304 12.9691 3.43069C13.7567 4.21834 14.1992 5.28663 14.1992 6.40054C14.1992 7.51445 13.7567 8.58273 12.9691 9.37039C12.1814 10.158 11.1131 10.6005 9.99922 10.6005C8.88531 10.6005 7.81702 10.158 7.02937 9.37039C6.24172 8.58273 5.79922 7.51445 5.79922 6.40054Z"
                  fill="#557EAE"/>
                <path
                  d="M3.01182 13.4005C2.64311 13.3991 2.27774 13.4704 1.93665 13.6104C1.59557 13.7505 1.28548 13.9565 1.02418 14.2166C0.762878 14.4767 0.555497 14.7859 0.413932 15.1263C0.272366 15.4668 0.1994 15.8318 0.199219 16.2005C0.199219 18.5679 1.36542 20.3529 3.18822 21.5163C4.98302 22.6601 7.40222 23.2005 9.99922 23.2005C12.5962 23.2005 15.0154 22.6601 16.8102 21.5163C18.633 20.3543 19.7992 18.5665 19.7992 16.2005C19.7992 15.4579 19.5042 14.7457 18.9791 14.2206C18.454 13.6955 17.7418 13.4005 16.9992 13.4005H3.01182ZM1.59922 16.2005C1.59922 15.4263 2.22642 14.8005 3.01182 14.8005H16.9992C17.3705 14.8005 17.7266 14.948 17.9892 15.2106C18.2517 15.4731 18.3992 15.8292 18.3992 16.2005C18.3992 18.0331 17.5284 19.3981 16.057 20.3347C14.559 21.2909 12.4282 21.8005 9.99922 21.8005C7.57022 21.8005 5.43942 21.2909 3.94142 20.3347C2.47142 19.3967 1.59922 18.0345 1.59922 16.2005Z"
                  fill="#557EAE"/>
              </svg>
            </div>
            <div class="profile-main__option-title">{{ $vuetify.lang.t('$vuetify.vat') }}</div>

            <div class="profile-main__option-val">
              {{ currentProfile.van }}
            </div>
          </div>

          <div class="profile-main__option" v-if="currentProfile.address.street">
            <div class="profile-main__option-icon">
              <svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M9.99922 0.800537C8.51401 0.800537 7.08962 1.39054 6.03942 2.44074C4.98922 3.49094 4.39922 4.91533 4.39922 6.40054C4.39922 7.88575 4.98922 9.31013 6.03942 10.3603C7.08962 11.4105 8.51401 12.0005 9.99922 12.0005C11.4844 12.0005 12.9088 11.4105 13.959 10.3603C15.0092 9.31013 15.5992 7.88575 15.5992 6.40054C15.5992 4.91533 15.0092 3.49094 13.959 2.44074C12.9088 1.39054 11.4844 0.800537 9.99922 0.800537ZM5.79922 6.40054C5.79922 5.28663 6.24172 4.21834 7.02937 3.43069C7.81702 2.64304 8.88531 2.20054 9.99922 2.20054C11.1131 2.20054 12.1814 2.64304 12.9691 3.43069C13.7567 4.21834 14.1992 5.28663 14.1992 6.40054C14.1992 7.51445 13.7567 8.58273 12.9691 9.37039C12.1814 10.158 11.1131 10.6005 9.99922 10.6005C8.88531 10.6005 7.81702 10.158 7.02937 9.37039C6.24172 8.58273 5.79922 7.51445 5.79922 6.40054Z"
                  fill="#557EAE"/>
                <path
                  d="M3.01182 13.4005C2.64311 13.3991 2.27774 13.4704 1.93665 13.6104C1.59557 13.7505 1.28548 13.9565 1.02418 14.2166C0.762878 14.4767 0.555497 14.7859 0.413932 15.1263C0.272366 15.4668 0.1994 15.8318 0.199219 16.2005C0.199219 18.5679 1.36542 20.3529 3.18822 21.5163C4.98302 22.6601 7.40222 23.2005 9.99922 23.2005C12.5962 23.2005 15.0154 22.6601 16.8102 21.5163C18.633 20.3543 19.7992 18.5665 19.7992 16.2005C19.7992 15.4579 19.5042 14.7457 18.9791 14.2206C18.454 13.6955 17.7418 13.4005 16.9992 13.4005H3.01182ZM1.59922 16.2005C1.59922 15.4263 2.22642 14.8005 3.01182 14.8005H16.9992C17.3705 14.8005 17.7266 14.948 17.9892 15.2106C18.2517 15.4731 18.3992 15.8292 18.3992 16.2005C18.3992 18.0331 17.5284 19.3981 16.057 20.3347C14.559 21.2909 12.4282 21.8005 9.99922 21.8005C7.57022 21.8005 5.43942 21.2909 3.94142 20.3347C2.47142 19.3967 1.59922 18.0345 1.59922 16.2005Z"
                  fill="#557EAE"/>
              </svg>
            </div>

            <div class="profile-main__option-title">
              {{ $vuetify.lang.t('$vuetify.address') }}

            </div>

            <div class="profile-main__option-val">
              <a
                :href="'https://www.google.com/maps/search/?api=1&query='+currentProfile.address.street + '+' + currentProfile.address.house + '+' + currentProfile.address.city"
                target="_blank">
                {{ currentProfile.address.street }} {{ currentProfile.address.house }}
                {{ currentProfile.address.entrance ? currentProfile.address.entrance + ' ' : '' }}
                {{ currentProfile.address.flat }}, {{ currentProfile.address.index }}
                {{ currentProfile.address.city }}, {{ currentProfile.address.country }}
              </a>
            </div>

          </div>

          <button v-if="company != currentProfile.id" class="btn btn-secondary" @click="openRespond">
            {{ $vuetify.lang.t('$vuetify.offerResume') }}
          </button>
        </div>
      </div>
      <div class="profile-tabs cards__single">
        <div class="profile-tabs__head">

          <div class="profile-tabs__item" :class="{ selected: tab_selected === 0 }" @click="tab_selected = 0">
            {{ $vuetify.lang.t('$vuetify.menu.about') }}
          </div>
          <div class="profile-tabs__item" :class="{ selected: tab_selected === 1 }" @click="tab_selected = 1">
            {{ $vuetify.lang.t('$vuetify.menu.news') }}
          </div>
          <div class="profile-tabs__item" :class="{ selected: tab_selected === 2 }" @click="tab_selected = 2">
            {{ $vuetify.lang.t('$vuetify.menu.objects') }}
          </div>
          <div class="profile-tabs__item" :class="{ selected: tab_selected === 3 }" @click="tab_selected = 3">
            {{ $vuetify.lang.t('$vuetify.details') }}
          </div>
        </div>
        <div class="profile-tabs__content">
          <div v-if="0===tab_selected" class="profile-tabs__content-item">
            <div v-html="currentProfile.description"></div>
          </div>
          <div v-if="1===tab_selected" class="profile-tabs__content-item">

            <div class="news-item__list">
              <news-card v-for="item in news" :key="item.id"
                         :id="item.id"
                         :image="$media_url + item.photo_path"
                         :title="item.title"
                         :author="item.author ? (item.author.name + ' ' + item.author.lastname) : ''"
                         :date="item.create_date"
              ></news-card>
            </div>
          </div>
          <div v-if="2===tab_selected" class="profile-tabs__content-item">
            <div>
              <div class="page__sorts">
                <v-menu ref="date" v-model="portfolioDate"
                        :close-on-content-click="false" transition="scale-transition">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field class="search-field" :value="portfolioFilter.range.join(' ~ ')"
                                  @change="loadObjects" prepend-inner-icon="$calendar"
                                  :placeholder="$vuetify.lang.t('$vuetify.accounting.card.period')" outlined
                                  hide-details v-bind="attrs" v-on="on" readonly clearable
                                  @click:clear="portfolioFilter.range=[]; loadObjects()">
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="portfolioFilter.range" no-title first-day-of-week="1" show-week
                                 locale-first-day-of-year="4" show-adjacent-months range
                                 @input="portfolioFilter.range.length == 2  ? portfolioDate = false : portfolioDate = true"
                  ></v-date-picker>
                </v-menu>
                <v-checkbox v-model="portfolioFilter.current" :label="$vuetify.lang.t('$vuetify.current')"
                            @change="loadObjects"></v-checkbox>
              </div>
              <div class="profile-objects">
                <div class="profile-objects-list">
                  <div class="list flex-row flex-wrap">
                    <ProfileObjectCard v-for="object in objects" :key="object.id"
                                       :photo="object.photo_path"
                                       :object_name="object.name" :object_id="object.id"
                                       :start_date="object.date_start" :end_date="object.date_end"
                                       :show_client="false"
                    ></ProfileObjectCard>
                  </div>
                </div>
              </div>
            </div>
            <!--            <div class="profile-objects" v-if="objects">-->
            <!--              <div class="profile-objects-list">-->
            <!--                <div class="h2" @click="switch_object_list('start')">{{ $vuetify.lang.t('$vuetify.planning') }}</div>-->
            <!--                <div class="list" :class="{ 'm-hidden': objects_list_vis.start }">-->
            <!--                  <ProfileObjectCard v-for="object in objects.start" :key="object.id"-->
            <!--                                     :object_link="false" :object_name="object.name" :object_id="object.id"-->
            <!--                                     :start_date="object.date_start" :end_date="object.date_end"-->
            <!--                                     :show_client="false">-->
            <!--                  </ProfileObjectCard>-->
            <!--                </div>-->

            <!--              </div>-->
            <!--              <div class="profile-objects-list">-->
            <!--                <div class="h2" @click="switch_object_list('now')">{{ $vuetify.lang.t('$vuetify.inProgress') }}</div>-->
            <!--                <div class="list" :class="{ 'm-hidden': objects_list_vis.now }">-->

            <!--                  <ProfileObjectCard v-for="object in objects.now" :key="object.id"-->
            <!--                                     :object_name="object.name" :object_id="object.id"-->
            <!--                                     :start_date="object.date_start"-->
            <!--                                     :end_date="object.date_start"-->
            <!--                                     :show_client="false"-->
            <!--                  ></ProfileObjectCard>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--              <div class="profile-objects-list">-->
            <!--                <div class="list" :class="{ 'm-hidden': objects_list_vis.end }">-->

            <!--                  <div class="h2" @click="switch_object_list('end')">{{ $vuetify.lang.t('$vuetify.finished') }}</div>-->
            <!--                  <ProfileObjectCard v-for="object in objects.end" :key="object.id"-->
            <!--                                     :object_name="object.name" :object_id="object.id"-->
            <!--                                     :start_date="object.date_start"-->
            <!--                                     :end_date="object.date_start"-->
            <!--                                     :show_client="false"-->
            <!--                  ></ProfileObjectCard>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </div>-->
          </div>
          <div v-if="tab_selected === 3" class="profile-tabs__content-item">
            <div class="details accordions">
              <div class="details__accordion profile-object" v-for="detail in details" :key="detail.id"
                   @click="opened_detail = (opened_detail === detail.id ? 0 : detail.id)">
                <div class="profile-object__title details__title">
                  {{ detail.name }}
                </div>
                <div class="details__content accordion__content"
                     :class="{ 'accordion__content--close': opened_detail !== detail.id }">
                  <div class="detail__characteristic flex" v-for="(value, name) in detail.options"
                       :key="detail.id + name">
                    <span class="characteristics__title">{{ $vuetify.lang.t('$vuetify.' + name) }}</span>
                    <span class="characteristics__content">{{ value }}</span>
                  </div>
                  <div class="profile-object__company">
                    {{ detail.comment }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-form>

    <CoolLightBox
      :items="lightboxItems"
      :index="index"
      @close="index = null; lightboxItems=[]">
    </CoolLightBox>

    <SpinnerLoader :overlay="loader"></SpinnerLoader>

    <MakeOfferToCompanyModal v-model="makeOfferModal" :organization_id="currentProfile.id"></MakeOfferToCompanyModal>

  </div>
</template>

<script>
import ProfileObjectCard from "../parts/ProfileObjectCard.vue";
import SpinnerLoader from "@/components/SpinnerLoader";
// import DeleteIcon from "@/components/icons/DeleteIcon";
// import EditIcon from "@/components/icons/EditIcon";
// import DocumentIcon from "@/components/icons/DocumentIcon";
import {mapActions, mapGetters} from "vuex";
import NewsCard from "@/views/parts/NewsCard.vue";
import MakeOfferToCompanyModal from "@/components/MakeOfferToCompanyModal.vue";

export default {
  name: "company-profie-view",
  components: {
    MakeOfferToCompanyModal,
    NewsCard,
    // DocumentIcon,
    ProfileObjectCard,
    // EditIcon,
    // DeleteIcon,
    SpinnerLoader,
  },

  data: function () {
    return {
      profile: false,
      options_date: {day: 'numeric', month: 'numeric', year: 'numeric'},
      objects_list_vis: {
        start: false,
        now: false,
        end: false
      },
      tab_selected: 1,
      tmp: 5,
      currentProfile: {},
      valid: true,
      step: 1,
      details: [],
      opened_detail: 0,

      positions: [],
      positionsSelect: [],
      selectedPosition: {},
      deletedPositions: [],

      cards: [],
      selectedCard: {},
      deletedCards: [],
      loadedCards: 0,

      objects: {},
      portfolio: [],
      portfolioFilter: {
        current: true,
        range: []
      },
      portfolioDate: false,

      documents: [],
      sort: '',
      selectSorts: [
        {name: this.$vuetify.lang.t('$vuetify.sorts.byName'), value: 'name'},
        {name: this.$vuetify.lang.t('$vuetify.sorts.byCreateDate'), value: 'create_date'},
      ],
      newDocument: {
        name: '',
        path: '',
        user_profile_id: this.id
      },
      docs: null,
      loadedFiles: 0,
      addDocumentModal: false,
      document_to_delete: 0,
      confirm_document_modal: false,

      options: {address: "yes"},
      photo: null,
      photoHtml: [],
      signature: null,
      menu1: false,
      menuCard: {
        1: false,
      },
      editing: false,
      other_language_check: false,

      tmp_skills: {},

      lightboxItems: [],
      index: null,

      news: [],
      loader: false,
      form_loader: false,
      alertMsg: '',
      alertError: false,

      makeOfferModal: false,
      company: JSON.parse(localStorage.getItem('organization')).id,
    };
  },

  mounted: function () {
    this.loadData();

  },

  methods: {
    ...mapActions(['checkPermission']),

    loadData: function () {
      this.loader = true
      this.$axios({
        url: this.$hostname + "time-tracking/organization/profile/" + this.$route.params.id,
        type: "GET",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
      })
        .then((response) => {
          this.currentProfile = response.data.data.data;
          this.loadNews();
          this.loadObjects();
          this.loadDetails();
        })
        .catch((response) => {
          this.alertMsg = this.$catch(response);
          this.alertError = true;
        }).finally(() => {
        this.loader = false;
      });
    },
    loadNews() {
      this.$axios({
        url: this.$hostname + "time-tracking/organization/news/" + this.$route.params.id,
        type: "GET",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
      })
        .then((response) => {
          this.news = response.data.data.data;
        })
        .catch((response) => {
          this.alertMsg = this.$catch(response);
          this.alertError = true;
        });
    },
    loadObjects() {
      this.$axios({
        url: this.$hostname + "time-tracking/organization/objects/" + this.$route.params.id,
        type: "GET",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
        params: {
          current: this.portfolioFilter.current,
          range: JSON.stringify(this.portfolioFilter.range),
        }
      })
        .then((response) => {
          this.objects = response.data.data.data
          // this.objects.start = response.data.data.data.filter(item => new Date(item.date_start) > new Date() && !item.active);
          //
          // this.objects.now = response.data.data.data.filter(item => new Date(item.date_start) <= new Date() && !item.active);
          //
          // this.objects.end = response.data.data.data.filter(item => item.active);
        })
        .catch((response) => {
          this.alertMsg = this.$catch(response);
          this.alertError = true;
        });
    },
    loadDetails() {
      this.$axios({
        url: this.$hostname + "time-tracking/organization/details/" + this.currentProfile.id,
        method: "GET",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
      }).then((response) => {
        this.details = response.data.data.data
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      })
    },

    openRespond() {
      this.makeOfferModal = true
    },
  },

  computed: {
    ...mapGetters(['permissions']),
  },
  watch: {
    "portfolioFilter.range"() {
      if (this.portfolioFilter.range.length == 2) {
        this.loadObjects()
      }
    }
  }

};
</script>
